var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M8 0a8 8 0 110 16A8 8 0 018 0zm3.77 5.32c-.35-.36-.71-.36-1.07 0L6.94 9.08 5.3 7.44c-.36-.36-.72-.36-1.07 0-.36.35-.36.71 0 1.07l2.17 2.17c.18.18.36.27.54.27.19 0 .37-.09.55-.27l4.28-4.29c.36-.35.36-.71 0-1.07z", "fill-rule": "nonzero" } }] }, name: "check-circle", theme: "filled" };
export {
  e as default
};
